import { render, staticRenderFns } from "./FormulaTemplateList.vue?vue&type=template&id=589e193f"
import script from "./FormulaTemplateList.vue?vue&type=script&lang=js"
export * from "./FormulaTemplateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports